module.exports = __webpack_public_path__ + "static/logo-260922c400c4abf60121ad9890577549.png";